import React, { useEffect, useRef, useState } from 'react'
import BlockTitle from '../common/BlockTitle'
import classnames from 'classnames'
import { calculateStickyLimit, Sticky, Range } from '../common/Stiky'
import ScrollElememt from '../../../components/ScrollElement'
import useRandomId from '../../../hooks/useRandomId'
import './style.scss'

const parts = [
  {
    title: 'Contract Defense Patch',
    description:
      'The first security patch that can fix smart contract vulnerabilities based on audit results.',
  },
  {
    title: 'Logic Bug Defense',
    description:
      'The first product to defend against logic flaws among contracts and can protect against risks caused by business design flaws.',
  },
  {
    title: 'Malicious Bots Tracking',
    description:
      'The security defense rules with high degrees of security and freedom are iterated based on real and quantifiable data. We have accumulated a large amount of attacking samples and behavioral data by observing markers and analyzing behaviors of malicious bots over a long period of time.',
  },
  {
    title: '100% Defense',
    description: 'DeFi Economic (Price Manipulation) Attack Diagram.',
  },
]

type HighlightsLimits = [Range | null, Range | null]

const Highlights: React.FC = () => {
  const $containerRef = useRef<HTMLDivElement>(null)
  const [$container, set$container] = useState<HTMLDivElement | null>(null)
  const [$title, set$title] = useState<HTMLDivElement | null>(null)
  const [$titles, set$titles] = useState<HTMLDivElement | null>(null)
  const [activeIndex, setActiveIndex] = useState(-1)
  // const stickies = useMemo(() => {
  //   const ret: HTMLElement[] = []
  //   if ($title) {
  //     ret.push($title)
  //   }
  //   return ret
  // }, [$title])
  // const limits = useMemo<HighlightsLimits | null>
  const [limits, setLimits] = useState<HighlightsLimits | null>(null)
  const titleOnceKey = useRandomId()

  useEffect(() => {
    if (!$container || !$title || !$titles) return
    if (limits) return
    setLimits(
      calculateStickyLimit($container, [$title, $titles]) as HighlightsLimits
    )
  }, [limits, $container, $title, $titles])

  useEffect(() => {
    set$container($containerRef.current)
  }, [])

  return (
    <div id="highlights" ref={$containerRef}>
      <Sticky range={limits?.[0]} el={$title} zIndex={101}>
        <BlockTitle
          title="Highlights"
          getRef={(r) => set$title(r)}
          onceKey={titleOnceKey}
        />
      </Sticky>
      <div className="content container md">
        <Sticky range={limits?.[1]} el={$titles}>
          <div className="highlights-titles" ref={(dom) => set$titles(dom)}>
            <div className="wrap">
              {parts.map((p, i) => (
                <div
                  className={classnames('title', { active: i === activeIndex })}
                  key={i}
                >
                  {p.title}
                </div>
              ))}
            </div>
          </div>
        </Sticky>
        <div className="descriptions">
          {parts.map((p, i) => (
            <ScrollElememt
              key={i}
              className="description"
              onEnterChange={(enter, d, y) => {
                setActiveIndex(enter ? i : -1)
              }}
              enterClassName="enter"
              enterOffset={50}
            >
              <div className="subtitle">{p.title}</div>
              <div>{p.description}</div>
            </ScrollElememt>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Highlights
